import { Plus, Download } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { AuthButton } from '@/core/permissions/AuthButton';
import { DataFilterToolbar, type FilterDefinition } from '@/components/ui/DataFilterToolbar';

interface UtilityToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  statusFilter: string;
  onStatusChange: (status: string) => void;
}

export function UtilityToolbar({ search, onSearchChange, statusFilter, onStatusChange }: UtilityToolbarProps) {
  const navigate = useNavigate();

  const filterDefs: FilterDefinition[] = [
    {
      id: 'status',
      label: 'Tất cả trạng thái',
      options: [
        { value: 'operational', label: 'Hoạt động' },
        { value: 'maintenance_due', label: 'Cần bảo trì' },
        { value: 'faulty', label: 'Sự cố' },
        { value: 'inactive', label: 'Ngừng hoạt động' },
      ]
    }
  ];

  const actions = (
    <>
      <AuthButton module="utility" action="create" behavior="hide" variant="outline" className="h-9 sm:text-sm text-xs border-slate-200 shrink-0">
        <Download className="w-4 h-4 mr-2" />
        Xuất báo cáo
      </AuthButton>
      <AuthButton
        module="utility"
        action="create"
        behavior="disable"
        permissionReason="Bạn không có quyền thêm tiện ích mới"
        className="bg-emerald-600 hover:bg-emerald-700 text-white border-none h-9 sm:text-sm text-xs shrink-0 rounded-md px-3 flex items-center"
        onClick={() => navigate('/utility/new')}
      >
        <Plus className="w-4 h-4 mr-2" />
        Thêm tiện ích
      </AuthButton>
    </>
  );

  return (
    <DataFilterToolbar
      search={search}
      onSearchChange={onSearchChange}
      searchPlaceholder="Tìm kiếm theo tên, mã, loại, khu vực..."
      filterDefs={filterDefs}
      filterValues={{ status: statusFilter === 'all' ? '' : statusFilter }}
      onFilterChange={(key, value) => {
        if (key === 'status') {
          onStatusChange(value || 'all');
        }
      }}
      actions={actions}
    />
  );
}
